<template>
  <div :class="className">
    <svg
      :width="dynamicWidth"
      :height="dynamicHeight"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 1.25L11.75 11.75M1.25 11.75L11.75 1.25L1.25 11.75Z"
        stroke="black"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'CancelIcon',
  props: {
    dynamicWidth: {
      type: Number,
      default: 45
    },
    dynamicHeight: {
      type: String,
      default: '45'
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {}
}
</script>
